import { render, staticRenderFns } from "./LiquidacionesJugadoresView.vue?vue&type=template&id=1ad489fe&"
import script from "./LiquidacionesJugadoresView.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesJugadoresView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports